import ActionTypes from "../../../../constants/ActionTypes";
import { IGetBundleDataAction, ISetBundleDataAction, ISetSelectedProductsAction } from "./types";
import { IManhattanBundle } from "../../../../entities/manhattan/bundle/types";
import { IManhattanBundleSubmit, ISelectedFtthProduct, ISelectedOTTProduct } from "../../../../entities/manhattan/submit/types";

export function getBundleDataAction(bundle: IManhattanBundle): IGetBundleDataAction {
  return {
    type: ActionTypes.MANHATTAN.BUNDLE_DATA.GET_DATA,
    payload: bundle
  };
}

export function setBundleDataAction(bundleData: IManhattanBundleSubmit): ISetBundleDataAction {
  return {
    type: ActionTypes.MANHATTAN.BUNDLE_DATA.SET_DATA,
    payload: {
      segment: bundleData.segment,
      selectedProducts: bundleData.selectedProducts,
      lang: bundleData.lang,
    }
  };
}

export function setBundleSelectedDataAction(selectedProducts: ISelectedOTTProduct[] | ISelectedFtthProduct[]): ISetSelectedProductsAction {
  return {
    type: ActionTypes.MANHATTAN.BUNDLE_DATA.SET_SELECTED_PRODUCTS,
    payload: selectedProducts
  };
}
